import React from 'react'
import * as R from 'ramda'
import { capitalizeFirstLetter } from 'utils/stringFormat'
import { getTraitTranslation } from 'components/modals/TestsReportModal/tabs/helpers'

export const useGMAState = state => {
  const {
    factor,
    language,
    response,
    isCandidate,
    includeNormComparison = true,
    candidates,
    selectedCandidates,
  } = state

  const translations = response.map(response => {
    const {
      abstract = [],
      description = [],
      judgement,
    } = getTraitTranslation(
      factor,
      R.prop(factor, response.scores),
      language,
      isCandidate,
      includeNormComparison,
    )

    return {
      ...response,
      translation: { abstract, description, judgement },
    }
  })

  const single = candidates.length === 1

  const descriptions = translations[0].translation.description[0].split(
    translations[0].translation.judgement[0],
  )

  const scores = translations
    .filter(score => single || selectedCandidates?.[score.id])
    .map(score => {
      const gma = score.stats?.gma ?? {}
      return {
        score: capitalizeFirstLetter(score.translation.judgement[0]),
        time: Math.round((gma.seconds ?? 0) / 60),
        answers: gma.correct ?? 0,
        questions: gma.totalQuestions ?? 0,
        id: score.id,
      }
    })

  const allScores = translations.map(score => ({
    id: score.id,
    score: score.scores[factor] * 100,
  }))

  const disabled = allScores.reduce(
    (acc, trait) => ({ ...acc, [trait.id]: isNaN(trait.score) }),
    {},
  )

  return {
    state: {
      translations,
      single,
      descriptions,
      scores,
      allScores,
      disabled,
    },
  }
}
